import { routes, useNeedLogo } from '@builddocs/data-management'

import NavigationButton from './NavigationButton'

type LogoButtonProps = {
  onClick?: () => void
}

export const LogoButton = ({ onClick }: LogoButtonProps) => {
  const { withoutLogo } = useNeedLogo()

  return (
    <NavigationButton
      StackProps={{ sx: { px: 1, minWidth: 42, height: 42 } }}
      alt="Логотип сервиса ИД"
      disablePadding={true}
      icon={withoutLogo ? undefined : '/assets/img/logo.svg'}
      label={withoutLogo ? 'Исполнительная документация' : undefined}
      to={routes.navigator.base()}
      onClick={onClick}
    />
  )
}

export default LogoButton
